<template>
  <div>
    <!-- 頁面標題 -->
    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h4 class="mb-1">App技術支援管理</h4>
          <p class="text-muted mb-0">管理UniApp的技術支援配置和統計信息</p>
        </div>
        <div>
          <b-button
            variant="primary"
            @click="showConfigModal = true"
            class="mr-1"
          >
            <feather-icon icon="SettingsIcon" class="mr-50" />
            編輯配置
          </b-button>
          <b-button
            variant="info"
            @click="showContentModal = true"
          >
            <feather-icon icon="EditIcon" class="mr-50" />
            編輯內容
          </b-button>
        </div>
      </div>
    </b-card>

    <!-- 統計卡片 -->
    <b-row class="mt-2">
      <b-col lg="3" md="6" sm="6">
        <b-card class="text-center">
          <feather-icon icon="UsersIcon" size="24" class="text-primary mb-1" />
          <h3 class="font-weight-bolder mb-25">{{ stats.total_users || 0 }}</h3>
          <p class="card-text">總用戶數</p>
        </b-card>
      </b-col>
      <b-col lg="3" md="6" sm="6">
        <b-card class="text-center">
          <feather-icon icon="SmartphoneIcon" size="24" class="text-success mb-1" />
          <h3 class="font-weight-bolder mb-25">{{ stats.active_devices || 0 }}</h3>
          <p class="card-text">活躍設備</p>
        </b-card>
      </b-col>
      <b-col lg="3" md="6" sm="6">
        <b-card class="text-center">
          <feather-icon icon="SearchIcon" size="24" class="text-warning mb-1" />
          <h3 class="font-weight-bolder mb-25">{{ stats.total_searches || 0 }}</h3>
          <p class="card-text">總搜尋次數</p>
        </b-card>
      </b-col>
      <b-col lg="3" md="6" sm="6">
        <b-card class="text-center">
          <feather-icon icon="TrendingUpIcon" size="24" class="text-info mb-1" />
          <h3 class="font-weight-bolder mb-25">{{ stats.today_searches || 0 }}</h3>
          <p class="card-text">今日搜尋</p>
        </b-card>
      </b-col>
    </b-row>

    <!-- 當前配置 -->
    <b-card class="mt-2">
      <template #header>
        <h5 class="mb-0">當前配置</h5>
      </template>

      <b-row>
        <b-col md="6">
          <div class="mb-2">
            <strong>支援電話：</strong>
            <span class="ml-1">{{ config.support_phone || '-' }}</span>
          </div>
        </b-col>
        <b-col md="6">
          <div class="mb-2">
            <strong>服務時間：</strong>
            <span class="ml-1">{{ config.service_hours || '-' }}</span>
          </div>
          <div class="mb-2">
            <strong>公司名稱：</strong>
            <span class="ml-1">{{ config.company_name || '-' }}</span>
          </div>
          <div class="mb-2" v-if=false>
            <strong>App版本：</strong>
            <span class="ml-1">{{ config.app_version || '-' }}</span>
          </div>
        </b-col>
      </b-row>

      <div class="mt-2 pt-2 border-top">
        <small class="text-muted">
          最後更新：{{ config.updated_at ? formatDate(config.updated_at) : '-' }}
        </small>
      </div>
    </b-card>

    <!-- 配置編輯模態框 -->
    <b-modal
      v-model="showConfigModal"
      title="編輯App技術支援配置"
      size="lg"
      @ok="updateConfig"
      @cancel="resetForm"
    >
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group label="支援電話" label-for="support_phone">
              <b-form-input
                id="support_phone"
                v-model="form.support_phone"
                placeholder="請輸入支援電話"
                required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
          </b-col>
          <b-col md="12">
            <b-form-group label="服務時間" label-for="service_hours">
              <b-form-input
                id="service_hours"
                v-model="form.service_hours"
                placeholder="例：週一至週五 09:00-18:00"
                required
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="公司名稱" label-for="company_name">
              <b-form-input
                id="company_name"
                v-model="form.company_name"
                placeholder="請輸入公司名稱"
                required
              />
            </b-form-group>
          </b-col>
          <b-col md="6" v-if=false>
            <b-form-group label="App版本" label-for="app_version">
              <b-form-input
                id="app_version"
                v-model="form.app_version"
                placeholder="例：1.0.0"
                required
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- 內容編輯模態框 -->
    <b-modal
      v-model="showContentModal"
      title="編輯App內容"
      size="xl"
      @ok="updateContent"
      @cancel="resetContentForm"
    >
      <b-tabs>
        <b-tab title="使用說明" active>
          <div class="mt-3">
            <h6>使用說明步驟</h6>
            <div v-for="(step, index) in contentForm.usage_guide" :key="index" class="mb-3">
              <b-row>
                <b-col md="2">
                  <b-form-input
                    v-model="step.number"
                    placeholder="步驟號"
                    readonly
                  />
                </b-col>
                <b-col md="8">
                  <b-form-textarea
                    v-model="step.text"
                    placeholder="步驟說明"
                    rows="2"
                  />
                </b-col>
                <b-col md="2">
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="removeUsageStep(index)"
                    v-if="contentForm.usage_guide.length > 1"
                  >
                    刪除
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-button variant="success" size="sm" @click="addUsageStep">
              添加步驟
            </b-button>
          </div>
        </b-tab>

        <b-tab title="常見問題">
          <div class="mt-3">
            <h6>常見問題列表</h6>
            <div v-for="(faq, index) in contentForm.faq" :key="index" class="mb-3 border p-3">
              <b-form-group label="問題">
                <b-form-input
                  v-model="faq.question"
                  placeholder="請輸入問題"
                />
              </b-form-group>
              <b-form-group label="答案">
                <b-form-textarea
                  v-model="faq.answer"
                  placeholder="請輸入答案"
                  rows="3"
                />
              </b-form-group>
              <b-button
                variant="danger"
                size="sm"
                @click="removeFaq(index)"
                v-if="contentForm.faq.length > 1"
              >
                刪除問題
              </b-button>
            </div>
            <b-button variant="success" size="sm" @click="addFaq">
              添加問題
            </b-button>
          </div>
        </b-tab>

        <b-tab title="問題排解">
          <div class="mt-3">
            <h6>問題排解列表</h6>
            <div v-for="(trouble, index) in contentForm.troubleshooting" :key="index" class="mb-3 border p-3">
              <b-form-group label="問題">
                <b-form-input
                  v-model="trouble.problem"
                  placeholder="請輸入問題"
                />
              </b-form-group>
              <b-form-group label="解決方案">
                <b-form-textarea
                  v-model="trouble.solution"
                  placeholder="請輸入解決方案"
                  rows="3"
                />
              </b-form-group>
              <b-button
                variant="danger"
                size="sm"
                @click="removeTroubleshooting(index)"
                v-if="contentForm.troubleshooting.length > 1"
              >
                刪除問題
              </b-button>
            </div>
            <b-button variant="success" size="sm" @click="addTroubleshooting">
              添加問題
            </b-button>
          </div>
        </b-tab>

        <b-tab title="使用條款">
          <div class="mt-3">
            <b-form-group label="使用條款內容">
              <b-form-textarea
                v-model="contentForm.terms_of_service"
                placeholder="請輸入使用條款"
                rows="10"
              />
            </b-form-group>
          </div>
        </b-tab>

        <b-tab title="隱私政策">
          <div class="mt-3">
            <b-form-group label="隱私政策內容">
              <b-form-textarea
                v-model="contentForm.privacy_policy"
                placeholder="請輸入隱私政策"
                rows="10"
              />
            </b-form-group>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BTabs,
  BTab
} from 'bootstrap-vue'

export default {
  name: 'AppSupportManagement',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BTabs,
    BTab
  },
  data() {
    return {
      config: {},
      stats: {},
      content: {},
      showConfigModal: false,
      showContentModal: false,
      form: {
        support_phone: '',
        service_hours: '',
        company_name: '',
        app_version: ''
      },
      contentForm: {
        usage_guide: [],
        faq: [],
        troubleshooting: [],
        terms_of_service: '',
        privacy_policy: ''
      },
      loading: false
    }
  },
  mounted() {
    this.loadConfig()
    this.loadStats()
    this.loadContent()
  },
  methods: {
    async loadConfig() {
      try {
        const response = await axiosIns.get('/app_support/config')
        if (response.data.success) {
          this.config = response.data.data
        }
      } catch (error) {
        console.error('載入配置失敗:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: '錯誤',
            text: '載入配置失敗',
            icon: 'AlertTriangleIcon',
            variant: 'danger'
          }
        })
      }
    },

    async loadStats() {
      try {
        const response = await axiosIns.get('/app_support/stats')
        if (response.data.success) {
          this.stats = response.data.data
        }
      } catch (error) {
        console.error('載入統計失敗:', error)
      }
    },

    async updateConfig() {
      try {
        this.loading = true
        const response = await axiosIns.put('/app_support/config', this.form)

        if (response.data.success) {
          this.config = response.data.data
          this.showConfigModal = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: '成功',
              text: '配置更新成功',
              icon: 'CheckIcon',
              variant: 'success'
            }
          })
        }
      } catch (error) {
        console.error('更新配置失敗:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: '錯誤',
            text: error.response?.data?.message || '更新配置失敗',
            icon: 'AlertTriangleIcon',
            variant: 'danger'
          }
        })
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.form = {
        support_phone: this.config.support_phone || '',
        service_hours: this.config.service_hours || '',
        company_name: this.config.company_name || '',
        app_version: this.config.app_version || ''
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      return new Date(dateString).toLocaleString('zh-TW')
    },

    // 載入內容
    async loadContent() {
      try {
        const response = await axiosIns.get('/app_support/content')
        if (response.data.success) {
          this.content = response.data.data
        }
      } catch (error) {
        console.error('載入內容失敗:', error)
      }
    },

    // 更新內容
    async updateContent() {
      try {
        this.loading = true
        const data = {
          usage_guide: JSON.stringify(this.contentForm.usage_guide),
          faq: JSON.stringify(this.contentForm.faq),
          troubleshooting: JSON.stringify(this.contentForm.troubleshooting),
          terms_of_service: this.contentForm.terms_of_service,
          privacy_policy: this.contentForm.privacy_policy
        }

        const response = await axiosIns.put('/app_support/content', data)

        if (response.data.success) {
          this.content = response.data.data
          this.showContentModal = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: '成功',
              text: '內容更新成功',
              icon: 'CheckIcon',
              variant: 'success'
            }
          })
        }
      } catch (error) {
        console.error('更新內容失敗:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: '錯誤',
            text: error.response?.data?.message || '更新內容失敗',
            icon: 'AlertTriangleIcon',
            variant: 'danger'
          }
        })
      } finally {
        this.loading = false
      }
    },

    // 重置內容表單
    resetContentForm() {
      this.contentForm = {
        usage_guide: this.content.usage_guide ? JSON.parse(this.content.usage_guide) : [
          { number: '1', text: '在X Data資料庫搜尋系統中輸入上方的 6 位數驗證碼' }
        ],
        faq: this.content.faq ? JSON.parse(this.content.faq) : [
          { question: '如何使用驗證碼？', answer: '在搜尋頁面輸入App顯示的6位數驗證碼即可進行身份驗證。' }
        ],
        troubleshooting: this.content.troubleshooting ? JSON.parse(this.content.troubleshooting) : [
          { problem: '驗證碼顯示錯誤', solution: '請檢查網路連接，重新啟動App或聯繫技術支援。' }
        ],
        terms_of_service: this.content.terms_of_service || '',
        privacy_policy: this.content.privacy_policy || ''
      }
    },

    // 使用說明方法
    addUsageStep() {
      const nextNumber = (this.contentForm.usage_guide.length + 1).toString()
      this.contentForm.usage_guide.push({
        number: nextNumber,
        text: ''
      })
    },

    removeUsageStep(index) {
      this.contentForm.usage_guide.splice(index, 1)
      // 重新編號
      this.contentForm.usage_guide.forEach((step, i) => {
        step.number = (i + 1).toString()
      })
    },

    // FAQ方法
    addFaq() {
      this.contentForm.faq.push({
        question: '',
        answer: ''
      })
    },

    removeFaq(index) {
      this.contentForm.faq.splice(index, 1)
    },

    // 問題排解方法
    addTroubleshooting() {
      this.contentForm.troubleshooting.push({
        problem: '',
        solution: ''
      })
    },

    removeTroubleshooting(index) {
      this.contentForm.troubleshooting.splice(index, 1)
    }
  },

  watch: {
    showConfigModal(newVal) {
      if (newVal) {
        this.resetForm()
      }
    },

    showContentModal(newVal) {
      if (newVal) {
        this.resetContentForm()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-25 {
  margin-bottom: 0.25rem !important;
}

.mr-50 {
  margin-right: 0.5rem !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.text-center {
  text-align: center !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-primary {
  color: #7367f0 !important;
}

.text-success {
  color: #28c76f !important;
}

.text-warning {
  color: #ff9f43 !important;
}

.text-info {
  color: #00cfe8 !important;
}

.font-weight-bolder {
  font-weight: 700 !important;
}

.d-flex {
  display: flex !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.align-items-center {
  align-items: center !important;
}

.card-text {
  margin-bottom: 0;
  color: #6c757d;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}
</style>
